import React from 'react';
import BaseComponent from './BaseComponent';

const defStyle = {color: '#f44336', fontSize: '.8em', width: '100%'};

export default ({ style, ...rest }) => (
    <BaseComponent as={'span'} style={{ ...defStyle, ...style }} {...rest}/>
);
